export const CopyIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" clip-path="url(#clip0_786_32828)">
      <path
        d="M10.1787 0V1.46378H1.46378V11.6426H0V1.46378C0 1.05537 0.14143 0.709548 0.425581 0.425581C0.708994 0.142168 1.05537 0 1.46378 0H10.1787ZM12.3574 2.92755C12.7431 2.92755 13.0776 3.06972 13.3616 3.35314C13.645 3.6371 13.7872 3.97184 13.7872 4.35736V14.536C13.7872 14.9446 13.645 15.2903 13.3616 15.5744C13.0774 15.8578 12.7429 16 12.3574 16H4.35754C3.94895 16 3.60276 15.8578 3.31916 15.5744C3.03501 15.2903 2.89358 14.9446 2.89358 14.536V4.35754C2.89358 3.97184 3.03501 3.63729 3.31916 3.35332C3.60258 3.06991 3.94895 2.92774 4.35754 2.92774H12.3574V2.92755ZM12.3574 14.536V4.35754H4.35754V14.5362H12.3574V14.536Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_32828">
        <rect width="13.7872" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CopyIcon2 = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 7.33203C4 5.44641 4 4.5036 4.58579 3.91782C5.17157 3.33203 6.11438 3.33203 8 3.33203H10C11.8856 3.33203 12.8284 3.33203 13.4142 3.91782C14 4.5036 14 5.44641 14 7.33203V10.6654C14 12.551 14 13.4938 13.4142 14.0796C12.8284 14.6654 11.8856 14.6654 10 14.6654H8C6.11438 14.6654 5.17157 14.6654 4.58579 14.0796C4 13.4938 4 12.551 4 10.6654V7.33203Z" stroke="black" />
    <path d="M4 12.6654C2.89543 12.6654 2 11.7699 2 10.6654V6.66536C2 4.15121 2 2.89413 2.78105 2.11308C3.5621 1.33203 4.81918 1.33203 7.33333 1.33203H10C11.1046 1.33203 12 2.22746 12 3.33203" stroke="black" />
  </svg>

);
export const CopyIcon4 = (props) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M7 7V5C7 2.79086 8.79086 1 11 1L17 1C19.2091 1 21 2.79086 21 5V11C21 13.2091 19.2091 15 17 15H15M7 7H5C2.79086 7 1 8.79086 1 11V17C1 19.2091 2.79086 21 5 21H11C13.2091 21 15 19.2091 15 17V15M7 7H11C13.2091 7 15 8.79086 15 11V15" stroke="#1C274C" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>


);
export const CopyIcon3 = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 7.79102C4.25 5.78755 4.25 4.78581 4.8724 4.16341C5.4948 3.54102 6.49653 3.54102 8.5 3.54102H10.625C12.6285 3.54102 13.6302 3.54102 14.2526 4.16341C14.875 4.78581 14.875 5.78755 14.875 7.79102V11.3327C14.875 13.3362 14.875 14.3379 14.2526 14.9603C13.6302 15.5827 12.6285 15.5827 10.625 15.5827H8.5C6.49653 15.5827 5.4948 15.5827 4.8724 14.9603C4.25 14.3379 4.25 13.3362 4.25 11.3327V7.79102Z"
      stroke="#474747"
      stroke-width="1.5"
    />
    <path
      d="M4.25 13.4577C3.07639 13.4577 2.125 12.5063 2.125 11.3327V7.08268C2.125 4.41139 2.125 3.07574 2.95486 2.24588C3.78473 1.41602 5.12037 1.41602 7.79167 1.41602H10.625C11.7986 1.41602 12.75 2.36741 12.75 3.54102"
      stroke="#474747"
      stroke-width="1.5"
    />
  </svg>
);
